export default {
    name: 'menu',
    menu: null,

    constructor()
    {
        this.menu = document.querySelector(".js-hamburger-menu");
        this.hamburger = document.querySelector(".js-hamburger");

        this.menuItems = this.menu ? this.menu.querySelectorAll('a') : [];
        this.mobileMenuItems = document.querySelectorAll('.js-hamburger-menu-item');
    },
    init() {
        this.constructor();
        this.run();
    },
    run(){
        // avoid js errors when menu not exists
        if (! this.hamburger) {
            return false;
        }

        this.watch();

        this.mobileMenuItems.forEach((el, i) => {
            el.style.transitionDelay = i * 0.08 + "s";
        });
    },
    watch(){
        this.hamburger.addEventListener("click", e =>{
            e.stopPropagation();
            this.toggle();
        });

        window.addEventListener("click", e => {
            let target = e.target;

            if(!this.menu.contains(target) && this.menu.classList.contains("active")){
              this.toggle();
            }
        });

        document.addEventListener("keydown", e => {
            if(event.keyCode === 27 && this.isMenuOpen()){
               this.toggle();
           }
        });

        this.menuItems.forEach(el => {
            el.addEventListener("blur", e => {
                if(e.target == this.menuItems[this.menuItems.length-1]){
                    this.hamburger.focus();
                }
            });
        });
    },
    toggle(){
        this.menu.classList.toggle("active");
        this.hamburger.classList.toggle("is-active");
        let ariaExpanded = this.menu.getAttribute('aria-expanded') == "false" ? "true" : "false";
        this.menu.setAttribute('aria-expanded', ariaExpanded);
        document.body.classList.toggle('no-scroll');

        this.mobileMenuItems.forEach(item => {
            if(!item.classList.contains('active')){
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
            
        });
    },
    isMenuOpen(){
        return this.menu.classList.contains("active");
    }

}